import React from "react";
import MuiDateRangeCalendar from "./daterange.calendar.styled";
import { CustomeDateRangeCalendarProps } from "./daterange.calendar.types";

const DateRangCalendar = ({ className, ...rest }: CustomeDateRangeCalendarProps) => (
  <MuiDateRangeCalendar className={`${className ?? ""}`} {...rest} />
);

export default DateRangCalendar;
